import { AxiosPromise, AxiosStatic } from "axios";
import { GetGlossaryResponse, GlossaryFilter } from "../types/Glossary";

export const getGlossary =
  (serverURL: string, appAxios: AxiosStatic) =>
  async (filters: GlossaryFilter = {}): AxiosPromise<GetGlossaryResponse> =>
    await appAxios.get(`${serverURL}/glossary`, {
      params: filters,
      withCredentials: true,
    });
